module.exports = __webpack_public_path__ + "media/images/hitfun/icon.mainmenu.actives-9db87eeb9e35f8e75687507d8ebc31cc.svg";